var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tinymce"},[_c('Editor',{attrs:{"init":_vm.init},model:{value:(_vm.contentValue),callback:function ($$v) {_vm.contentValue=$$v},expression:"contentValue"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }